import { render, staticRenderFns } from "./TheMenu.vue?vue&type=template&id=5a79b8a6&scoped=true&"
import script from "./TheMenu.vue?vue&type=script&lang=js&"
export * from "./TheMenu.vue?vue&type=script&lang=js&"
import style0 from "./TheMenu.vue?vue&type=style&index=0&id=5a79b8a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a79b8a6",
  null
  
)

export default component.exports